module.exports = "<div>{{parameter.bigDecimalValue|percentage:3}}</div>";